export enum colorEnums {
  CircularBook = 'Circular Book'
}
